/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdminNew_lists$ref: FragmentReference;
declare export opaque type AdminNew_lists$fragmentType: AdminNew_lists$ref;
export type AdminNew_lists = {|
  +id: string,
  +$refType: AdminNew_lists$ref,
|};
export type AdminNew_lists$data = AdminNew_lists;
export type AdminNew_lists$key = {
  +$data?: AdminNew_lists$data,
  +$fragmentRefs: AdminNew_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminNew_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = 'c57183bdc9c537430162bd5e2ab9d43b';

module.exports = node;
